export enum ErrorMessage {
  BALANCE_TOO_LOW = 'Not enough balance',
  BALANCE_TOO_LOW_TO_BET = 'Insufficent funds to bet',
  BET_TOO_LOW = 'BET_TOO_LOW',
  DEPOSIT_TOO_LOW = 'Deposit amount is less than minimal. Try a larger amount.',
  DEPOSIT_NOT_FOUND = 'DEPOSIT_NOT_FOUND',
  GAME_ROOM_NOT_FOUND = 'Game room not found',
  INVALID_PAYOUT_ADDRESS = 'Invalid withdrawal address',
  TOO_FEW_PERMISSIONS = 'TOO_FEW_PERMISSIONS',
  PAYOUT_NOT_FOUND = 'Withdraw not found',
  INVALID_TELEGRAM_INIT_DATA = 'Invalid telegram init data',
  USER_NOT_FOUND = 'User not found',
  GAME_NOT_STARTED = 'Game not started',
  USER_PAYLOAD_NOT_FOUND = 'USER_PAYLOAD_NOT_FOUND',
  LOTTERY_NUMBER_PICKED = 'LOTTERY_NUMBER_PICKED',
  LOTTERY_NO_PICKS = 'LOTTERY_NO_PICKS',
  LOTTERY_INVALID_PICK = 'LOTTERY_INVALID_PICK',
  INTERNAL_ERROR = 'Internal error',
  SCHEMA_VALIDATION_EXCEPTION = 'SCHEMA_VALIDATION_EXCEPTION',
  REFERRAL_STAT_NOT_FOUND = 'REFERRAL_STAT_NOT_FOUND',
  INSUFFICIENT_SYSTEM_BALANCE = 'Failed to create a withdraw. We are already informed about this issue and resolving it. Try using another currency or repeat withdraw in a few hours',
  PAYOUT_TOO_LOW = 'Withdraw amount is less than minimal. Try a larger amount.',
  INVALID_REFERRAL_CODE_FORMAT = 'Invalid referral code format',
  REFERRAL_CODE_ALREADY_EXISTS = 'Referral code already exists',
  REFERRAL_CODE_CAN_NOT_BE_CHANGED = 'You can change referral code only once per month',
}
